import { createResource } from '../utils/resource'

const gtpClassStore = createResource('gtpclass', {})

export default gtpClassStore
